import { Component, inject, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CompanyModel } from '../../../models/company.model';
import { CompaniesService } from '../../../services/company.service';
import { ToastService } from '../../../services/toast.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { KeeniconComponent } from '../../keenicon/keenicon.component';
import { ToastrModule } from 'ngx-toastr';

@Component({
	selector: 'app-create-edit-company',
	templateUrl: './create-edit-company.component.html',
	styleUrls: ['./create-edit-company.component.scss'],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, ToastrModule, KeeniconComponent],
	standalone: true,
})
export class CreateEditCompanyComponent implements OnInit, OnDestroy {
	form: FormGroup;
	private unsubscribe: Subscription[] = [];

	private fb = inject(FormBuilder);
	private companiesService = inject(CompaniesService);
	public dialogRef = inject(MatDialogRef<CreateEditCompanyComponent>);
	@Inject(MAT_DIALOG_DATA) public data: any;
	private toastService = inject(ToastService);

	ngOnInit() {
		this.initForm();
	}

	initForm() {
		this.form = this.fb.group({
			name: new FormControl('', [Validators.required, Validators.minLength(3)]),
			legalName: new FormControl('', [Validators.required, Validators.minLength(3)]),
			vat: new FormControl('', [Validators.required, Validators.minLength(9)]),
			email: new FormControl('', [Validators.required, Validators.minLength(8), Validators.email]),
			addressCity: new FormControl(''),
			addressCountry: new FormControl(''),
			address: new FormControl(''),
			addressZipCode: new FormControl(''),
			phone: new FormControl(''),
			website: new FormControl(''),
		});
	}

	prepareCompany() {
		let company: CompanyModel = new CompanyModel();

		this.form.controls['name'].setValue(this.form.controls['name'].value.trim());
		this.form.controls['legalName'].setValue(this.form.controls['legalName'].value.trim());

		Object.keys(this.form.controls).forEach((key: string) => {
			const controlValue = this.form.controls[key].value;
			if (controlValue !== undefined && controlValue !== null && controlValue !== '') {
				(company as any)[key] = controlValue;
			}
		});

		Object.keys(company).forEach((key: string) => {
			const companyKey = key as keyof CompanyModel;
			if (company[companyKey] === undefined || company[companyKey] === null || company[companyKey] === '') {
				delete company[companyKey];
			}
		});

		return company;
	}

	createACompany() {
		if (this.form.valid) {
			const company = this.prepareCompany();
			this.companiesService.add(company).subscribe({
				next: (res: any) => {
					this.companiesService.company$.next(res.company);
					this.toastService.success('toast_company_created', 'Success');
				},
				error: (err) => {
					this.toastService.error('toast_error_creating_company', 'Error');
				},
				complete: () => {
					this.closeDialog();
				},
			});
		}
	}

	closeDialog() {
		this.dialogRef.close(true);
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}
}
